var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer_2",
    width: 24,
    height: 24,
    "data-name": "Layer 2",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#2b2e45}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7197",
    d: "M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4z",
    className: "prefix__cls-2",
    "data-name": "Path 7197"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7198",
    d: "M18 21a1 1 0 0 0 1-1 7 7 0 1 0-14 0 1 1 0 0 0 1 1z",
    className: "prefix__cls-2",
    "data-name": "Path 7198"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.d0e5ba20c713b4f2ac35f5b38156c6ce.svg";
export { ForwardRef as ReactComponent };